export const environment = {
  production: false,
  urlAdmin: 'https://staging.api.admon.sofipacorporation.com.mx/api',
  rrhhUrl: 'https://staging.api.rrhh.sofipacorporation.com.mx/api',
  urlback: 'https://staging.api.gruti.sofipacorporation.com.mx/api',
  urlFirmasDig: 'http://104.154.87.114:8080/admin/api/usuarios/firmas',
};
